<template>
  <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="18" cy="18" r="18" fill="#F36F2E"/>
    <path d="M25 11.019V25.019H11V11.019H25ZM26.1 9.01904H9.9C9.4 9.01904 9 9.41904 9 9.91904V26.119C9 26.519 9.4 27.019 9.9 27.019H26.1C26.5 27.019 27 26.519 27 26.119V9.91904C27 9.41904 26.5 9.01904 26.1 9.01904ZM17 13.019H23V15.019H17V13.019ZM17 17.019H23V19.019H17V17.019ZM17 21.019H23V23.019H17V21.019ZM13 13.019H15V15.019H13V13.019ZM13 17.019H15V19.019H13V17.019ZM13 21.019H15V23.019H13V21.019Z" fill="white"/>
  </svg>
</template>
<script>
export default {
  name: "BbcSelectCourses",
}
</script>